var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"application-components-scene-wrapper"},[_c('application-public',{attrs:{"prop":"applicationHomeUnderground","identification":"应用案例-地下空间","list":_vm.list}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }